import {
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
  UncontrolledAccordion,
} from "reactstrap";

import { getUrlFiles } from "../../utils/services/files";
import { createAppBuildConfig } from "../../utils/services/mobileAppsBuildConfig";

import ButtonSpinner from "../../components/Buttons/ButtonSpinner";
import DeleteButton from "../../components/Buttons/DeleteButton";
import { useRef, useState } from "react";

import { FaImage, FaBell, FaApple } from "react-icons/fa6";
import { IoIosColorPalette } from "react-icons/io";

import "./styled.css";

import ColorPicker from "../../components/ColorPicker/ColorPicker";
import AppPreview from "../../components/AppPreview/AppPreview";
import ModalOrientationApple from "./ModalOrientationApple";
import ModalOrientationFirebase from "./ModalOrientationFirebase";

import useImageObjectUrl from "../../utils/hooks/useImageObjectUrl";

import SweetAlert from "react-bootstrap-sweetalert";

export const ModalVersionAppNew = (props) => {
  const { isOpen, toggle, app, token, refetch } = props;

  const [name, setName] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [version, setVersion] = useState("");
  const [versionCode, setVersionCode] = useState("");

  const [firebaseAndroidFile, setFirebaseAndroidFile] = useState(null);
  const [appleProvisionCert, setAppleProvisionCert] = useState(null);
  const [applePushCert, setApplePushCert] = useState(null);
  const [ascAppId, setAscAppId] = useState("");
  const [firstAcess, setFirstAcess] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [changeColorsLogin, setChangeColorsLogin] = useState(true);
  const [loginTopColor, setLoginTopColor] = useState("#fff");
  const [loginBottomColor, setLoginBottomColor] = useState("#fff");
  const [loginCopyrightColor, setLoginCopyrightColor] = useState("");
  const [eventsListBackgroundColor, setEventsListBackgroundColor] =
    useState("");
  const [eventsListTextColor, setEventsListTextColor] = useState("");
  const [eventsListDateColor, setEventsListDateColor] = useState("");
  const [iconImage, setIconImage] = useState(null);
  const [splashImage, setSplashImage] = useState(null);
  const [logoLoginImage, setLogoLoginImage] = useState(null);
  const [logoEventListImage, setLogoEventListImage] = useState(null);
  const [loginBackgroundImage, setLoginBackgroundImage] = useState(null);
  const [isLoading, setIsloading] = useState(false);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [iconImageError, setIconImageError] = useState("");
  const [splashImageError, setSplashImageError] = useState("");
  const [logoLoginImageError, setLogoLoginImageError] = useState("");
  const [logoEventListImageError, setLogoEventListImageError] = useState("");
  const [firebaseAndroidFileError, setFirebaseAndroidFileError] = useState("");
  const [ascAppIdError, setAscAppIdError] = useState("");

  // urls locais das imagens recém escolhidas, para as miniaturas e o preview
  // refletirem a escolha antes do upload acontecer
  const iconPreviewUrl = useImageObjectUrl(iconImage);
  const splashPreviewUrl = useImageObjectUrl(splashImage);
  const logoLoginPreviewUrl = useImageObjectUrl(logoLoginImage);
  const logoEventListPreviewUrl = useImageObjectUrl(logoEventListImage);
  const loginBackgroundPreviewUrl = useImageObjectUrl(loginBackgroundImage);

  // modal
  const [modalApple, setModalApple] = useState(false);
  const [modalFireBase, setModalFireBase] = useState(false);

  const loginBackgroundInputRef = useRef(null);

  // limpa a imagem de fundo escolhida. o value do input também é zerado, senão
  // escolher o mesmo arquivo de novo não dispara o onChange
  function clearLoginBackground() {
    setLoginBackgroundImage(null);

    if (loginBackgroundInputRef.current) {
      loginBackgroundInputRef.current.value = "";
    }
  }

  async function getImage(fileName) {
    let pictures = [];
    let haveImg = false;
    let data = new FormData();

    if (fileName === "iconImage") {
      if (iconImage && iconImage.type.startsWith("image/")) {
        data.append("files", iconImage);
        haveImg = true;
      }
    }

    if (fileName === "splashImage") {
      if (splashImage && splashImage.type.startsWith("image/")) {
        data.append("files", splashImage);
        haveImg = true;
      }
    }

    if (fileName === "logoLoginImage") {
      if (logoLoginImage && logoLoginImage.type.startsWith("image/")) {
        data.append("files", logoLoginImage);
        haveImg = true;
      }
    }
    if (fileName === "logoEventListImage") {
      if (logoEventListImage && logoEventListImage.type.startsWith("image/")) {
        data.append("files", logoEventListImage);
        haveImg = true;
      }
    }

    if (fileName === "loginBackgroundImage") {
      if (
        loginBackgroundImage &&
        loginBackgroundImage.type.startsWith("image/")
      ) {
        data.append("files", loginBackgroundImage);
        haveImg = true;
      }
    }

    if (fileName === "firebaseAndroidFile") {
      // if (logoEventListImage && logoEventListImage.type.startsWith("image/")) {
      data.append("files", firebaseAndroidFile);
      haveImg = true;
      // }
    }

    data.append("folder", `mobile-app-build-config-bundle/${app?.bundleId}`);
    data.append("eventId", "8029badb-d64c-4af8-9f52-59b60e346767");

    if (haveImg) {
      try {
        const response = await getUrlFiles(data, token);

        response.forEach((img, i) => {
          if (img) {
            pictures.push({ image: img.url, expires: img.expires });
          }
        });
      } catch (error) {
        console.log(error);
        setErrorAlert(true);
        return;
      }

      return pictures[0].image;
    }
  }

  // Converte um File em string base64 pura (sem o prefixo `data:...;base64,`)
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split("base64,")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const isValidImageFile = (file) => {
    return file instanceof File && file.type.startsWith("image/");
  };

  const isValidJsonFile = (file) => {
    if (!(file instanceof File)) return false;

    const extension = file.name.split(".").pop().toLowerCase();
    return extension === "json";
  };

  function preValidateColumns() {
    const icon = isValidImageFile(iconImage);
    const splash = isValidImageFile(splashImage);
    const logoLogin = isValidImageFile(logoLoginImage);
    const logoEventList = isValidImageFile(logoEventListImage);
    const firebase = isValidJsonFile(firebaseAndroidFile);

    // o background da tela de login é opcional, então fica fora daqui
    const images = icon && splash && logoLogin && logoEventList && firebase;

    // certificados Apple: basta o arquivo ter sido escolhido. o id do app no
    // App Store Connect é obrigatório junto com eles
    const appleCerts =
      appleProvisionCert instanceof File &&
      applePushCert instanceof File &&
      ascAppId.trim() !== "";

    //colors
    // a cor do rodapé e as da lista de eventos são opcionais: sem elas o app
    // usa os valores padrão
    const loginColors =
      !changeColorsLogin || (loginTopColor !== "" && loginBottomColor !== "");

    const colors = primaryColor !== "" && secondaryColor !== "" && loginColors;

    //versions
    const versionCodes = versionCode !== "" && version !== "";

    return images && appleCerts && colors && versionCodes;
  }

  function validateImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      img.onload = () => resolve(true); // imagem válida
      img.onerror = () => resolve(false); // imagem inválida
    });
  }
  async function submitForm() {
    if (ascAppId.trim() === "") {
      setAscAppIdError("Campo obrigatório.");
      return;
    }

    setIsloading(true);

    try {
      const iconImage = await getImage("iconImage");
      const splashImage = await getImage("splashImage");
      const logoLoginImage = await getImage("logoLoginImage");
      const logoEventListImage = await getImage("logoEventListImage");
      const loginBackgroundImage = await getImage("loginBackgroundImage");
      const firebaseAndroidFile = await getImage("firebaseAndroidFile");
      const appleProvisionCertUploaded = await fileToBase64(appleProvisionCert);
      const applePushCertUploaded = await fileToBase64(applePushCert);

      if (iconImage) {
        const valid = await validateImage(iconImage);
        if (!valid) {
          setIconImageError("Imagem inválida.");
          return;
        }
      }

      if (splashImage) {
        const valid = await validateImage(splashImage);
        if (!valid) {
          setSplashImageError("Imagem inválida.");
          return;
        }
      }

      if (logoLoginImage) {
        const valid = await validateImage(logoLoginImage);
        if (!valid) {
          setLogoLoginImageError("Imagem inválida.");
          return;
        }
      }

      if (logoEventListImage) {
        const valid = await validateImage(logoEventListImage);
        if (!valid) {
          setLogoEventListImageError("Imagem inválida.");
          return;
        }
      }

      const data = {
        name: app?.name,
        bundleId: app?.bundleId,
        colorHexaPrimary: primaryColor,
        colorHexaSecondary: secondaryColor,
        icon: iconImage,
        splash: splashImage,
        logoLoginScreen: logoLoginImage,
        logoEventListScreen: logoEventListImage,
        hasFirstAccess: firstAcess,
        firebasePushFile: firebaseAndroidFile,
        appleProvisionCert: appleProvisionCertUploaded,
        applePushCert: applePushCertUploaded,
        ascAppId: ascAppId.trim(),
        isVersionedAndroid: true,
        isVersionedApple: true,
        versionApp: version,
        versionCode: versionCode,
        status: "PENDENTE",
        changeColorsLogin: changeColorsLogin,
        loginTopColor: loginTopColor,
        loginBottomColor: loginBottomColor,
        loginCopyrightColor: loginCopyrightColor,
        loginBackgroundImage: loginBackgroundImage || "",
        eventsListBackgroundColor: eventsListBackgroundColor,
        eventsListTextColor: eventsListTextColor,
        eventsListDateColor: eventsListDateColor,
      };

      const sendApi = await createAppBuildConfig(data);
      console.log(sendApi);
      if (sendApi?.message === "created") {
        setShowSuccessAlert(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsloading(false);
    }
  }

  function clearRefImg() {
    setIconImage(null);
    setSplashImage(null);
    setLogoLoginImage(null);
    setLogoEventListImage(null);
    setLoginBackgroundImage(null);
    setFirebaseAndroidFile(null);
    setAscAppId("");
    setAscAppIdError("");
  }
  return (
    <>
      {modalApple && (
        <ModalOrientationApple
          isOpen={modalApple}
          toggle={() => setModalApple(false)}
        />
      )}

      {modalFireBase && (
        <ModalOrientationFirebase
          isOpen={modalFireBase}
          toggle={() => setModalFireBase(false)}
        />
      )}

      {showSuccessAlert ? (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            clearRefImg();
            refetch();
            toggle();
            // props.data();
            setShowSuccessAlert(false);
          }}
        >
          {"Configuração criada com sucesso!"}
        </SweetAlert>
      ) : null}

      <Modal size="xl" isOpen={isOpen} autoFocus={true} centered={true}>
        <ModalHeader toggle={toggle}>Gerar Versão</ModalHeader>
        <ModalBody className="modal-version-app__body">
          <div className="modal-version-app__preview">
            <AppPreview
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              changeColorsLogin={changeColorsLogin}
              loginTopColor={loginTopColor}
              loginBottomColor={loginBottomColor}
              loginCopyrightColor={loginCopyrightColor}
              loginLogoUrl={logoLoginPreviewUrl}
              eventsListLogoUrl={logoEventListPreviewUrl}
              loginBackgroundUrl={loginBackgroundPreviewUrl}
              eventsListBackgroundColor={eventsListBackgroundColor}
              eventsListTextColor={eventsListTextColor}
              eventsListDateColor={eventsListDateColor}
              hasFirstAccess={firstAcess}
            />
          </div>

          <form className="modal-version-app__form">
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Nome do Aplicativo*
                  <div
                    id="nameApp"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="nameApp"
                    >
                      Nome que será exibido nas lojas e no dispositivo do
                      usuário quando o APP for baixado
                    </UncontrolledTooltip>
                  </div>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={app?.name}
                  disabled={true}
                  // onChange={(e) => setName(e.target.value)}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Bundle ID*
                  <div
                    id="bundleId"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="bundleId"
                    >
                      Código identificador do APP nas lojas
                    </UncontrolledTooltip>
                  </div>
                </label>
                <input
                  className="form-control"
                  type="text"
                  disabled={true}
                  value={app?.bundleId}
                  // onChange={(e) => setBundleId(e.target.value)}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <UncontrolledAccordion>
                <AccordionItem>
                  <AccordionHeader targetId={1}>
                    <label
                      style={{
                        fontSize: 18,
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                      }}
                    >
                      <FaImage size={20} />
                      Imagens
                    </label>
                  </AccordionHeader>
                  <AccordionBody accordionId={1}>
                    <Row>
                      <Col md={6} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Ícone *
                          <div
                            id="icon"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="icon"
                            >
                              1536x1536px
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFile1"
                          onChange={(e) => setIconImage(e.target.files?.[0])}
                        />
                        <p style={{ color: "red" }}>{iconImageError}</p>
                        {iconPreviewUrl && (
                          <Col md={6} style={{ marginTop: 10 }}>
                            <img
                              src={iconPreviewUrl}
                              alt="Ícone do aplicativo"
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "contain",
                              }}
                            />
                          </Col>
                        )}
                      </Col>

                      <Col md={6} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Splash *
                          <div
                            id="splash"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="splash"
                            >
                              4096x4096px
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFile2"
                          onChange={(e) => setSplashImage(e.target.files?.[0])}
                        />
                        {splashPreviewUrl && (
                          <Col md={6} style={{ marginTop: 10 }}>
                            <img
                              src={splashPreviewUrl}
                              alt="Splash do aplicativo"
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "contain",
                              }}
                            />
                          </Col>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Logo tela de login *
                          <div
                            id="loginScreen"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="loginScreen"
                            >
                              300x200px
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFile3"
                          onChange={(e) =>
                            setLogoLoginImage(e.target.files?.[0])
                          }
                        />
                        {logoLoginPreviewUrl && (
                          <Col md={6} style={{ marginTop: 10 }}>
                            <img
                              src={logoLoginPreviewUrl}
                              alt="Logo da tela de login"
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "contain",
                              }}
                            />
                          </Col>
                        )}
                      </Col>

                      <Col md={6} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Logo lista de eventos *
                          <div
                            id="logoEvent"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="logoEvent"
                            >
                              300x200px
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFile3"
                          onChange={(e) =>
                            setLogoEventListImage(e.target.files?.[0])
                          }
                        />
                        {logoEventListPreviewUrl && (
                          <Col md={6} style={{ marginTop: 10 }}>
                            <img
                              src={logoEventListPreviewUrl}
                              alt="Logo da lista de eventos"
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "contain",
                              }}
                            />
                          </Col>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Background Tela de Login
                          <div
                            id="loginBackground"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="loginBackground"
                            >
                              1080x1920px. Se enviada, substitui as cores de
                              fundo da tela de login
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFileLoginBackground"
                          ref={loginBackgroundInputRef}
                          onChange={(e) =>
                            setLoginBackgroundImage(e.target.files?.[0])
                          }
                        />
                        {loginBackgroundPreviewUrl && (
                          <Col
                            md={6}
                            style={{
                              marginTop: 10,
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <img
                              src={loginBackgroundPreviewUrl}
                              alt="Background da tela de login"
                              style={{
                                width: 80,
                                height: 80,
                                objectFit: "contain",
                              }}
                            />
                            <DeleteButton
                              id="removeLoginBackgroundNew"
                              tooltip="Remover a imagem de fundo"
                              onClick={() => clearLoginBackground()}
                            />
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem>
                  <AccordionHeader targetId={2}>
                    <label
                      style={{
                        fontSize: 18,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <IoIosColorPalette size={20} />
                      Cores
                    </label>
                  </AccordionHeader>
                  <AccordionBody accordionId={2}>
                    <label
                      className="form-label text-sm"
                      style={{ fontWeight: "bold" }}
                    >
                      Tema:
                    </label>
                    <Row className="gx-2" style={{ marginBottom: "20px" }}>
                      <Col xs="auto">
                        <ColorPicker
                          classOfContainer="primary-card-pickr"
                          setStateFunc={setPrimaryColor}
                          defaultColor={primaryColor}
                          labelText="Cor Primária *"
                          tip="Cor principal do aplicativo"
                          idDiv="corPrincipalCards"
                        />
                      </Col>
                      <Col xs="auto">
                        <ColorPicker
                          classOfContainer="secondary-card-pickr"
                          setStateFunc={setSecondaryColor}
                          defaultColor={secondaryColor}
                          labelText="Cor Secundária *"
                          tip="Cor dos detalhes do aplicativo (Exemplos: Toogles, alguns botões)"
                          idDiv="corSecundariaCards"
                        />
                      </Col>
                    </Row>

                    {/* <Row style={{ marginBottom: "20px" }}>
                      <Col md={12}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Alterar cores do Login?
                        </label>
                        <select
                          value={changeColorsLogin === true}
                          className="form-control"
                          onChange={({ target }) =>
                            setChangeColorsLogin(target.value === "true")
                          }
                        >
                          <option value="true">Sim</option>
                          <option value="false">Não</option>
                        </select>
                      </Col>
                    </Row> */}

                    {changeColorsLogin && (
                      <>
                        <label
                          className="form-label text-sm"
                          style={{ fontWeight: "bold" }}
                        >
                          Tela de Login:
                        </label>
                        <Row className="gx-1" style={{ marginBottom: "20px" }}>
                          <Col xs="auto">
                            <ColorPicker
                              classOfContainer="septenary-card-pickr"
                              setStateFunc={setLoginTopColor}
                              defaultColor={loginTopColor}
                              labelText="Cor 1 (Parte de cima) *"
                              tip="Cor que será exibida na parte de cima da tela de login"
                              idDiv="corLoginTop"
                            />
                          </Col>

                          <Col xs="auto">
                            <ColorPicker
                              classOfContainer="octonary-card-pickr"
                              setStateFunc={setLoginBottomColor}
                              defaultColor={loginBottomColor}
                              labelText="Cor 2 (Parte de baixo) *"
                              tip="Cor que será exibida na parte de baixo da tela de login"
                              idDiv="corLoginBottom"
                            />
                          </Col>

                          <Col xs="auto">
                            <ColorPicker
                              classOfContainer="nonary-card-pickr"
                              setStateFunc={setLoginCopyrightColor}
                              defaultColor={loginCopyrightColor}
                              labelText="Cor 3 (Texto do rodapé)"
                              tip="Cor do texto de copyright exibido no rodapé da tela de login"
                              idDiv="corLoginCopyright"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

                    <label
                      className="form-label text-sm"
                      style={{ fontWeight: "bold" }}
                    >
                      Tela de Eventos:
                    </label>
                    <Row className="gx-1" style={{ marginBottom: "20px" }}>
                      <Col xs="auto">
                        <ColorPicker
                          classOfContainer="events-list-bg-pickr"
                          setStateFunc={setEventsListBackgroundColor}
                          defaultColor={eventsListBackgroundColor}
                          labelText="Cor Fundo Lista de Eventos"
                          tip="Cor de fundo da tela de lista de eventos"
                          idDiv="corEventsListBg"
                        />
                      </Col>

                      <Col xs="auto">
                        <ColorPicker
                          classOfContainer="events-list-text-pickr"
                          setStateFunc={setEventsListTextColor}
                          defaultColor={eventsListTextColor}
                          labelText="Cor Texto Lista de Eventos"
                          tip="Cor da saudação, do subtítulo e dos botões Atualizar e Sair, incluindo os ícones"
                          idDiv="corEventsListText"
                        />
                      </Col>

                      <Col xs="auto">
                        <ColorPicker
                          classOfContainer="events-list-date-pickr"
                          setStateFunc={setEventsListDateColor}
                          defaultColor={eventsListDateColor}
                          labelText="Cor Data do Card"
                          tip="Cor da data no rodapé do card do evento, incluindo o ícone de relógio"
                          idDiv="corEventsListDate"
                        />
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem>
                  <AccordionHeader targetId={3}>
                    <label
                      style={{
                        fontSize: 18,
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                      }}
                    >
                      <FaBell size={20} />
                      Push Notifications Android
                    </label>
                  </AccordionHeader>
                  <AccordionBody accordionId={3}>
                    <Row style={{ marginTop: 10 }}>
                      <Col md={12}>
                        <Button
                          color="primary"
                          onClick={() => setModalFireBase(true)}
                        >
                          Orientações Firebase
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Arquivo Firebase (Android) *
                          <div
                            id="push"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="push"
                            >
                              Arquivo de configuração para notificações do
                              aplicativo.
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFileFirebase"
                          onChange={(e) =>
                            setFirebaseAndroidFile(e.target.files?.[0])
                          }
                        />
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem>
                  <AccordionHeader targetId={4}>
                    <label
                      style={{
                        fontSize: 18,
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                      }}
                    >
                      <FaApple size={20} />
                      Apple Store
                    </label>
                  </AccordionHeader>
                  <AccordionBody accordionId={4}>
                    <Row>
                      <Col md={12}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Apple App Id *
                          <div
                            id="ascAppId"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="ascAppId"
                            >
                              Identificador numérico do aplicativo no App Store
                              Connect
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={ascAppId}
                          onChange={(e) => {
                            setAscAppId(e.target.value);
                            setAscAppIdError("");
                          }}
                        />
                        {ascAppIdError && (
                          <span style={{ color: "red", fontSize: 12 }}>
                            {ascAppIdError}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: 10 }}>
                      <Col md={12}>
                        <Button
                          color="primary"
                          onClick={() => setModalApple(true)}
                        >
                          Orientações Apple
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Certificado de provisionamento *
                          <div
                            id="appleProvisionCert"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="appleProvisionCert"
                            >
                              Arquivo de perfil de provisionamento do aplicativo
                              Apple.
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFileAppleProvision"
                          onChange={(e) =>
                            setAppleProvisionCert(e.target.files?.[0])
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} style={{ marginTop: 10 }}>
                        <label
                          className="form-label text-sm"
                          style={{ display: "flex" }}
                        >
                          Certificado de push *
                          <div
                            id="applePushCert"
                            style={{ height: "16px", paddingRight: "7px" }}
                          >
                            <div className="show-tips">
                              <span>?</span>
                            </div>
                            <UncontrolledTooltip
                              style={{ backgroundColor: "#6f42c1" }}
                              placement="right"
                              target="applePushCert"
                            >
                              Arquivo de certificado de push notifications para
                              o aplicativo Apple.
                            </UncontrolledTooltip>
                          </div>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="formFileApplePush"
                          onChange={(e) =>
                            setApplePushCert(e.target.files?.[0])
                          }
                        />
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </UncontrolledAccordion>
            </Row>
            <Row style={{ marginTop: 10, marginBottom: 20 }}>
              <Col lg={12}>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Possui primeiro acesso?
                  <div
                    id="firstAcess"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="firstAcess"
                    >
                      Caso selecione "Não" o botão Primeiro acesso não será
                      exibido no aplicativo
                    </UncontrolledTooltip>
                  </div>
                </label>
                <select
                  value={firstAcess}
                  className="form-control"
                  onChange={({ target }) =>
                    setFirstAcess(target.value === "true")
                  }
                >
                  <option value={true}>Sim</option>
                  <option value={false}>Não</option>
                </select>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 10 }}>
                <label className="form-label">Versão: *</label>
                <input
                  className="form-control"
                  type="text"
                  value={version}
                  onChange={(e) => setVersion(e.target.value)}
                />
              </Col>
              <Col style={{ marginTop: 10 }}>
                <label className="form-label"> Código de Versão: *</label>
                <input
                  className="form-control"
                  type="text"
                  value={versionCode}
                  onChange={(e) => setVersionCode(e.target.value)}
                />
              </Col>
            </Row>

            <Row
              style={{
                width: "100%",
                marginTop: 15,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="success"
                className="btn btn-danger waves-effect waves-light"
                style={{ width: 80, marginRight: 5 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>

              {/* <Button
              color="success"
              className="btn waves-effect waves-light"
              style={{ width: 120, marginRight: 5 }}
              // onClick={() => toggle()}
              onClick={() => submitForm()}
            >
              Gerar versão
            </Button> */}

              <Button
                color={
                  isLoading || !preValidateColumns() ? "secondary" : "success"
                }
                className="btn waves-effect waves-light"
                style={{ width: isLoading ? "auto" : 120, marginLeft: 0 }}
                disabled={isLoading || !preValidateColumns()}
                onClick={() => submitForm()}
                type="submit"
              >
                {isLoading ? <Spinner size="sm" /> : null}
                <span> Gerar versão</span>
              </Button>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};
